<div class="container my-4">
  <div class="row mx-0">
    <h3 class="color-theme font-weight-bold mb-0">{{"Gestione ospiti" | translate}} - {{"Calendari personalizzati" | translate}}</h3>
  </div>

  <div class="row mx-0 my-3">
    <div class="container d-flex m-0 p-0">
      <div class="col-6 pl-0">
        <div class="form-group">
          <label for="name">{{"Nome" | translate }} *</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            aria-describedby="name"
            [(ngModel)]="filter.name"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-0 my-3">
    <div class="container d-flex m-0 p-0">
      <div class="col-4 pl-0">
        <div class="form-group">
          <label for="datefrom">
            {{ "Da" | translate }}
          </label>
          <div>
            <input
              [(ngModel)]="filter.data.period.from"
              style="width: 100%"
              type="date"
              class="form-control"
              id="datefrom"
              name="datefrom"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="customername">
            {{ "Nome ospite" | translate }}
          </label>
          <div>
            <input
              [(ngModel)]="filter.data.customername"
              type="text"
              style="width: 100%"
              class="form-control"
              id="customername"
              name="customername"
            />
          </div>
        </div>
      </div>
      <div class="col-4 pl-0">
        <div class="form-group">
          <label for="dateto">
            {{ "A" | translate }}
          </label>
          <div>
            <input
              [(ngModel)]="filter.data.period.to"
              style="width: 100%"
              type="date"
              class="form-control"
              id="dateto"
              name="dateto"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="customerlastname">
            {{ "Cognome ospite" | translate }}
          </label>
          <div>
            <input
              [(ngModel)]="filter.data.customerlastname"
              type="text"
              style="width: 100%"
              class="form-control"
              id="customerlastname"
              name="customerlastname"
            />
          </div>
        </div>
      </div>
      <div class="col-4 pl-0">
        <div class="form-group">
          <label for="orderstatusFilter">
            {{ "Status prenotazione" | translate }}
          </label>
          <div style="display: flex; flex-direction: row">
            <select
              class="form-control"
              name="orderstatusFilter"
              [(ngModel)]="filter.data.orderstatus"
            >
              <option [ngValue]="-1">
                {{ "Nessun filtro" | translate }}
              </option>

              <option [ngValue]="0">
                {{ "In Attesa" | translate }}
              </option>

              <option [ngValue]="1">
                {{ "Accettata" | translate }}
              </option>

              <option [ngValue]="2">
                {{ "Rifiutata" | translate }}
              </option>

              <option [ngValue]="3">
                {{ "Processata" | translate }}
              </option>

              <option [ngValue]="4">
                {{ "Cancellata" | translate }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for="customeremail">
            {{ "Email ospite" | translate }}
          </label>
          <div>
            <input
              [(ngModel)]="filter.data.customeremail"
              style="width: 100%"
              type="email"
              class="form-control"
              id="customeremail"
              name="customeremail"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-0 my-3">
    <div class="container d-flex m-0 p-0">
      <div class="col-3 pl-0">
        <div class="form-group">
          <label for="categoryFilter0">
            {{ "Categoria root" | translate }}
          </label>

          <div style="display: flex; flex-direction: row">
            <select
              class="form-control"
              name="categoryFilter0"
              [(ngModel)]="filter.data.categoryroot"
              (change)="selectCategory(0)"
            >
              <option [ngValue]="null">
                {{ "Nessun filtro" | translate }}
              </option>

              <option
                *ngFor="
                  let element of categoriesSelect.categoryObj0.categories
                "
                [ngValue]="element.id"
              >
                {{ element.title.it }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-3 pl-0">
        <div class="form-group">
          <label for="categoryFilter1"> {{ "Categoria" | translate }} 1 </label>

          <div style="display: flex; flex-direction: row">
            <select
              class="form-control"
              name="categoryFilter1"
              [(ngModel)]="filter.data.categoryl1"
              (change)="selectCategory(1)"
            >
              <option [ngValue]="null">
                {{ "Nessun filtro" | translate }}
              </option>

              <option
                *ngFor="
                  let element of categoriesSelect.categoryObj1.categories
                "
                [ngValue]="element.id"
              >
                {{ element.title.it }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-3 pl-0">
        <div class="form-group">
          <label for="categoryFilter2"> {{ "Categoria" | translate }} 2 </label>

          <div style="display: flex; flex-direction: row">
            <select
              class="form-control"
              name="categoryFilter2"
              [(ngModel)]="filter.data.categoryl2"
              (change)="selectCategory(2)"
            >
              <option [ngValue]="null">
                {{ "Nessun filtro" | translate }}
              </option>

              <option
                *ngFor="
                  let element of categoriesSelect.categoryObj2.categories
                "
                [ngValue]="element.id"
              >
                {{ element.title.it }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-3 pl-0">
        <div class="form-group">
          <label for="categoryFilter3"> {{ "Categoria" | translate }} 3 </label>

          <div style="display: flex; flex-direction: row">
            <select
              class="form-control"
              name="categoryFilter3"
              [(ngModel)]="filter.data.categoryl3"
              (change)="selectCategory(3)"
            >
              <option [ngValue]="null">
                {{ "Nessun filtro" | translate }}
              </option>

              <option
                *ngFor="
                  let element of categoriesSelect.categoryObj3.categories
                "
                [ngValue]="element.id"
              >
                {{ element.title.it }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-0 my-3">
    <div class="container d-flex m-0 p-0">
      <div class="col-4 pl-0">
        <div class="form-group">
          <label for="service">
            {{ "Servizio" | translate }}
          </label>

          <div style="display: flex; flex-direction: row">
            <select
              class="form-control"
              name="service"
              [(ngModel)]="filter.data.service"
            >
              <option [ngValue]="null">
                {{ "Nessun filtro" | translate }}
              </option>

              <option
                *ngFor="let element of categoriesSelect.currentServiceList"
                [ngValue]="element.id"
              >
                {{ element.title.it }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-4 pl-0">
        <div class="form-group">
          <label for="filterLabel">
            {{ "Etichetta" | translate }}
          </label>

          <div>
            <select
              id="filterLabel"
              class="form-control"
              name="filterLabel"
              [(ngModel)]="filter.data.label"
            >
              <option [ngValue]="''">
                {{ "Nessun filtro" | translate }}
              </option>

              <option
                *ngFor="let element of allLabels"
                [ngValue]="element.id"
              >
                {{ element.name.it }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-4 pl-0">
        <div class="form-group">
          <label for="filterDepartment">
            {{ "Reparto" | translate }}
          </label>

          <div>
            <select
              id="department"
              class="form-control"
              name="filterDepartment"
              [(ngModel)]="filter.data.department"
            >
              <option [ngValue]="''">
                {{ "Nessun filtro" | translate }}
              </option>

              <option
                *ngFor="let element of allDepartments"
                [ngValue]="element.id"
              >
                {{ element.name.it }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container d-flex m-0 p-0">
    <div class="d-flex justify-content-end">
      <div class="px-2">
        <button class="btn btn-primary" (click)="saveFilter()">{{ "Salva" | translate }}</button>
      </div>

      <button type="button" routerLink="/calendarFilters" class="btn btn-secondary"><i class="bi bi-arrow-90deg-left"></i> {{ "Annulla" | translate }}</button>
    </div>
  </div>
</div>
